import Text from './Text'
import ExpandableText from './ExpandableText'

export { ExpandableText }
export default Text
